export const environment = {
    production: false,
    apiUrl: 'https://forumtalkapi.ibexfusion.com/',
    version: Date.now()
};
